import { loadFirebaseAuth } from "@/config/firebase-auth";

// --- AUTH METHODS ---

export const auth_signInGoogle = async () => {
    const { auth, firebaseAuth, isConfigured } = await loadFirebaseAuth();
    if (!isConfigured || !auth) {
        console.warn("Mock Google Sign In");
        return;
    }
    const provider = new firebaseAuth.GoogleAuthProvider();
    try {
        await firebaseAuth.signInWithPopup(auth, provider);
    } catch (error) {
        console.error("Error signing in with Google", error);
        throw error;
    }
};

export const auth_signInEmail = async (email: string, pass: string) => {
    const { auth, firebaseAuth, isConfigured } = await loadFirebaseAuth();
    if (!isConfigured || !auth) {
        return;
    }
    try {
        await firebaseAuth.signInWithEmailAndPassword(auth, email, pass);
    } catch (error) {
        console.error("Error signing in with Email", error);
        throw error;
    }
};

export const auth_signUpEmail = async (email: string, pass: string) => {
    const { auth, firebaseAuth, isConfigured } = await loadFirebaseAuth();
    if (!isConfigured || !auth) {
        return;
    }
    try {
        await firebaseAuth.createUserWithEmailAndPassword(auth, email, pass);
    } catch (error) {
        console.error("Error signing up with Email", error);
        throw error;
    }
};

export const auth_logout = async () => {
    const { auth, firebaseAuth, isConfigured } = await loadFirebaseAuth();
    if (!isConfigured || !auth) {
        return;
    }
    try {
        await firebaseAuth.signOut(auth);
    } catch (error) {
        console.error("Error signing out", error);
    }
};

export const auth_signInAnonymously = async () => {
    const { auth, firebaseAuth, isConfigured } = await loadFirebaseAuth();
    if (!isConfigured || !auth) {
        return;
    }
    try {
        await firebaseAuth.signInAnonymously(auth);
    } catch (error) {
        console.error("Error signing in anonymously", error);
        throw error;
    }
};
